import * as React from "react";
import { connect } from "react-redux";
import { selectResourceInfo } from "../../../balancingSelectors/selectBalancingResources";
import { IdStyles } from "../../../less/IdStyles";
import { selectPurchasePointsEventAmount } from "../../../selectors/selectPurchasePointsEventInfo";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { TradeTransitionArrow } from "../../generic/common/TradeTransitionArrow";
import { Icon } from "../../generic/icon/Icon";
import { IdIcon } from "../../generic/icon/IdIcon";
import { ResourceIcon } from "../../generic/icon/ResourceIcon";
import { List } from "../../generic/list/List";
import { NumberFormat } from "../../generic/number-format/NumberFormat";
import { TextLocaValueProportional } from "../../generic/text/TextLocaValueProportional";
import { IdTooltipAnchor, TooltipText } from "../../tooltip";
var renderRewardItem = function (reward, index) {
    var rewardResourceInfo = selectResourceInfo(reward.resourceId);
    return (React.createElement("div", { key: index, className: "flex flex--guts flex--stacked" },
        React.createElement(ResourceIcon, { resource: rewardResourceInfo, styleId: IdStyles.IconLarge }),
        React.createElement(NumberFormat, { className: IdStyles.TextBoldAccent, amount: reward.amount })));
};
export var _PurchasePointsPackage = function (_a) {
    var rewardItem = _a.rewardItem, purchasePointsEventAmount = _a.purchasePointsEventAmount;
    var isRequiredPointsThresholdMet = purchasePointsEventAmount.greaterThanOrEqual(rewardItem.requiredThreshold);
    var packageConnector = (React.createElement(React.Fragment, null, isRequiredPointsThresholdMet ? (React.createElement("div", null,
        React.createElement(Icon, { icon: IdIcon.CheckIcn, styleId: IdStyles.IconLarge }))) : (React.createElement("div", null,
        React.createElement(TradeTransitionArrow, null)))));
    return (React.createElement("div", { className: IdStyles.PurchasePointsPackageBackgroundContainer + " flex flex--spaced flex--aligned margin--large" },
        React.createElement("div", { className: IdStyles.PurchasePointsItemBackgroundContainerRequirement + " flex flex--guts flex--stacked" },
            React.createElement(TooltipText, { anchor: IdTooltipAnchor.Bottom, id: IdLoca.tooltip_purchasePoints_web },
                React.createElement(Icon, { icon: IdIcon.PointsIcn, styleId: IdStyles.IconLarge })),
            React.createElement(TextLocaValueProportional, { className: IdStyles.TextBoldAccent, required: rewardItem.requiredThreshold, available: purchasePointsEventAmount })),
        React.createElement("div", null, packageConnector),
        React.createElement("div", { className: IdStyles.PurchasePointsItemBackgroundContainer }, rewardItem.resourceReward != undefined && (React.createElement(List, { items: rewardItem.resourceReward, renderItem: renderRewardItem, className: "flex flex--row flex--around" })))));
};
var mapState = function (state) { return ({
    purchasePointsEventAmount: selectPurchasePointsEventAmount(state),
}); };
export var PurchasePointsPackage = connect(mapState)(_PurchasePointsPackage);



//////////////////
// WEBPACK FOOTER
// ./src/features/purchase-points-event/components/PurchasePointsPackage.tsx
// module id = 2887
// module chunks = 3